import { Box, Typography, Stack, Button } from '@mui/material'
import TextFieldsIcon from '@mui/icons-material/TextFields'
import AudioFileIcon from '@mui/icons-material/AudioFile'
import DescriptionIcon from '@mui/icons-material/Description'
import { resolveFileType } from '../AttachmentsCase/DataPart'

import { IFileDTO } from '../../store/materials/types'
import timeUtils from '../../utils/timeUtils'
import { IFile } from '../AttachmentsCase/types'
import CardTAG from '../CardTAG'
import ModalTAG from '../ModalTAG'
import TableTAG from '../TableTAG'
import { uploadInputZones } from '../UploadDropzone/types'



interface IMaterialMetadata {
  opened?: boolean
  close: any
  material?: IFile
}

const getPreviewElement = (material: IFile | undefined) =>{
  if(material){
    const typeToCheck: any = material?.extension ?? material?.extension
    
    let url = ''
    if (material instanceof File) {
      url = URL.createObjectURL(material)
    }

    const getBoxStyle = (iconStyle: any) => (
      <Box sx={{ width: '10rem', height: '10rem' }}>{iconStyle}</Box>
    )

    const getMediaElement = (src: string) => (
      <img
        src={src}
        style={{ objectFit: 'cover', width: '100%', height: '100%' }}
      />
    )

    if (material?.extension === uploadInputZones.TEXT_FIELD) {
      return getBoxStyle(
        <TextFieldsIcon sx={{ width: '100%', height: '100%' }} />,
      )
    }

    if (
      resolveFileType(typeToCheck) == uploadInputZones.DOCUMENT
    ) {
      return (
        <Box sx={{ width: '10rem', height: '10rem' }}>
          <DescriptionIcon sx={{ width: '100%', height: '100%' }} />
        </Box>
      )
    }

    
    if (resolveFileType(typeToCheck) === uploadInputZones.AUDIO) {
      return getBoxStyle(
        <AudioFileIcon sx={{ width: '100%', height: '100%' }} />,
      )
    }

    if (resolveFileType(typeToCheck) === uploadInputZones.VIDEO) {
      return (
        <Box sx={{ width: '10rem', height: '10rem' }} id='video'>
          <video
            style={{ objectFit: 'cover', width: '100%', height: '100%' }}
          >
            <source src={material instanceof File ? url : material?.link}></source>
          </video>
        </Box>
      )
    }

    if (material?.link) {
      return getBoxStyle(
        getMediaElement(material instanceof File ? url : material?.link),
      )
    }

    return getBoxStyle(getMediaElement(material instanceof File ? url : material?.link))
  }
}

const MaterialMetadata: React.FC<IMaterialMetadata> = ({ opened = false, close, material }) => {
  
  
  return (
    <ModalTAG open={opened} style={{ width: 'auto' }}>
      <CardTAG
        title={material ? material?.name : 'Uploaded Material'}
        closable={true}
        closeCard={close}
      >
        <Box sx={{ display: 'flex', gap: '3.5rem' }}>
          <Box sx={{ width: '30vw', height: '20vw' }}>
            {/* <img
              src={material?.link}
              style={{ objectFit: 'cover', width: '100%', height: '100%' }}
            /> */}
           { getPreviewElement(material)}
          </Box>
          <Box
            sx={{
              width: '40vw',
              display: 'flex',
              flexDirection: 'column',
              flexGrow: 1,
              gap: '3.5rem',
            }}
          >
            <Box sx={{ width: '70%', display: 'flex', flexDirection: 'column', gap: '2rem' }}>
              <Typography variant='bodyBold'>File Information</Typography>
              <Box
                sx={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  justifyContent: 'space-between',
                  rowGap: '2rem',
                }}
              >
                {/* <Stack sx={{ width: '50%' }}>
                  <Typography variant='labelBold'>Uploaded by</Typography>
                  <Typography variant='bodyRegular'>
                    {material?.uploader?.first_name} {material?.uploader?.last_name}
                  </Typography>
                </Stack> */}
                <Stack sx={{ width: '50%' }}>
                  <Typography variant='labelBold'>File Size</Typography>
                  <Typography variant='bodyRegular'>{material?.size}</Typography>
                </Stack>
                <Stack sx={{ width: '50%' }}>
                  <Typography variant='labelBold'>Upload Date</Typography>
                  <Typography variant='bodyRegular'>
                    {material && timeUtils.getFormatedDate(material?.uploaded_at)}
                  </Typography>
                </Stack>
                {/* <Stack sx={{ width: '50%' }}>
                  <Typography variant='labelBold'>File Type</Typography>
                  <Typography variant='bodyRegular'>Image</Typography>
                </Stack> */}
              </Box>
            </Box>
            <Box
                sx={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  justifyContent: 'space-between',
                  rowGap: '2rem',
                }}
              >
                <a href={material?.link} target="_blank" rel="noreferrer" download>
                  <Button variant='submitFormButton'>
                      <Typography variant='bodyBold'>Download</Typography>          
                  </Button>
                </a>   
              </Box>
          </Box>
        </Box>
      </CardTAG>
    </ModalTAG>
  )
}

export default MaterialMetadata
